"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteMenuNoteMutationOptions = exports.deleteMenuNoteMutation = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const menuPlanner_1 = require("../queries/menuPlanner");
exports.deleteMenuNoteMutation = client_1.gql `
  mutation DeleteMenuNote($id: String!) {
    deleteMenuNote(id: $id) {
      ok
    }
  }
`;
exports.deleteMenuNoteMutationOptions = (variables, menuPlannerQueryVariables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        deleteMenuNote: { __typename: "OkResponse", ok: true },
    },
    update: !menuPlannerQueryVariables
        ? undefined
        : store => {
            updateQuery_1.updateQuery(store, menuPlanner_1.menuPlannerQuery, x => {
                x.menuPlanner = x.menuPlanner.filter(y => y.id !== variables.id);
            }, menuPlannerQueryVariables);
        },
});
//# sourceMappingURL=deleteMenuNote.js.map